import {userConstants} from '../_constants';

export function orderCreateInfo(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ORDER_CREATE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_ORDER_CREATE_INFO_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.GET_ORDER_CREATE_INFO_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
